import {  GET_OPERATOR_CONTRACT_DETAIL_START,
    GET_OPERATOR_CONTRACT_DETAIL_ERROR,
    GET_OPERATOR_CONTRACT_DETAIL_SUCCESS,
    DOWNLOAD_CONTARCT_DETAIL_SUCCESS,
    DOWNLOAD_CONTARCT_DETAIL_ERROR,
    UPLOAD_CONTARCT_DETAIL_SUCCESS,
    UPLOAD_CONTARCT_DETAIL_ERROR
} from 'Constant'
  
const initialState = {
    loading: false,
    data: [],
   
};
  
export default function ContractVerificationReducer(
    state = { ...initialState },
    action
) {
    switch (action.type) {
      case GET_OPERATOR_CONTRACT_DETAIL_START:
        return {
          ...state,
          loading: true,
        };
      case GET_OPERATOR_CONTRACT_DETAIL_SUCCESS:
        return {
          ...state,
          data: action.payload,
          loading: false,
        };
      case GET_OPERATOR_CONTRACT_DETAIL_ERROR:
        return {
          ...state,
          loading: false,
          message: action.error.message,
        };
    
      default:
        return state;
    }
}
  